import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import { ModalBox } from "../Outer/Modal";
import Table from "react-bootstrap/Table";
import { CloseRounded } from "@mui/icons-material";
import {
  GetWinnerAuction,
  SecondaryMarketAuction,
  SecondaryMarketBidSell,
  SecondaryMarketAnnouncement,
  GetWinnerAuctionData,
  SecondaryMarketAuctionSell,
  SecondryMarketSMgetAuctionById,
} from "../../redux/auth-reducer/auth-service";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import * as icons from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import { Card, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { ToastContainer, toast } from "react-toastify";
import { DatePicker, Loader } from "rsuite";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { SignalRUrl } from "../../utils/config/config";
import { useHubEvent } from "../../hooks/useHubEvent";
import { useHubResync } from "../../hooks/useHubResync";
import { readApiMessage } from "../../utils/helper/helper";
import {
  RESALE_OVER_CODES,
  checkSellForm,
  resaleClosedMessage,
  sellRefusalMessage,
} from "../../utils/helper/resaleShare";
import {
  listingKey,
  mergePushedRows,
  normalizeGridRows,
  pageLivenessChanged,
  preferNewerRows,
  syncTimerEnds,
} from "../../utils/helper/auctionGrid";
import { parseServerUtc, withoutClockFields } from "../../utils/helper/lotClock";
import LotCountdown from "../../CommonComponent/LotCountdown";
import { bidTimeLabel } from "../../utils/helper/auctionForm";
import {
  DATE_TIME_REQUIRED,
  SELL_SHARE_REQUIRED,
} from "../../utils/helper/validation";

// The shares a resale can offer; the server accepts no other value (usp_InsertSMBidSell).
const SELL_SHARE_OPTIONS = [25, 50, 100];

// #191: the listings are merged from the pushes like the Auctions grid (auctionGrid.js), matched by
// listingKey - a team's level-1 and level-2 listings are different rows. Only the fields a push
// actually has are copied; a server that predates the bidder fields sends neither.
/** Fields a ReceiveSMBidStatus push carries for a listing. */
const SM_STATUS_FIELDS = [
  "status",
  "remainingBidTime",
  "totalPoolAmount",
  "bidPlacedBy",
  "bidPlacedByName",
  "serverNowUtc",
];
/** Fields a ReceiveCurrentSMBid push carries after someone bids. */
const SM_CURRENT_BID_FIELDS = ["remainingBidTime", "bidPlacedBy", "bidPlacedByName", "serverNowUtc"];

/**
 * When a push starts or stops a listing on the page, how long to wait before asking for the page
 * again: the status job opens the next listing and settles the last one on its own run, and the
 * Worker pushes that 2.5 s after a running listing's countdown ends.
 */
const PUSH_REFETCH_DELAY_MS = 2500;
/** Delay for refetches that do not race the status job. */
const QUICK_REFETCH_DELAY_MS = 400;
/** An Upcoming listing's start: the page is asked for again this long after it, then once more. */
const START_REFETCH_DELAY_MS = 1500;
const START_RETRY_MS = 3000;
const START_REFETCH_ATTEMPTS = 2;
/** Only a start this close gets a timer of its own; a later one is looked at again when it is. */
const START_LOOKAHEAD_MS = 10 * 60 * 1000;
/** The longest wait handed to setTimeout - beyond 2^31 - 1 ms it fires at once. */
const MAX_TIMEOUT_MS = 24 * 60 * 60 * 1000;

export const Secondary_Market = () => {
  const [data, setData] = useState(false);
  const [auctionWinner, setAuctionWinner] = useState([]);
  const [auctionToSellData, setAuctionToSellData] = useState("");
  const [startingBidToSell, setStartingBidToSell] = useState("");
  const [bidIncrementToSell, setBidIncrementToSell] = useState("");
  const [showView, setShowView] = useState(false);
  const [signalRData, setSignalRData] = useState([]);
  const [validated, setValidated] = useState(false);
  const [searchTextLive, setSearchTextLive] = useState();
  const [searchTextClose, setSearchTextClose] = useState("");
  const [searchTextUpcomingLive, setSearchTextUpcomingLive] = useState("");
  const [BidStatusAuction, setBidStatusAuction] = useState([]);
  // #191: the listings' clocks by listingKey (syncTimerEnds), kept apart from the rows so that
  // replacing the rows can never reset a countdown.
  const [clocks, setClocks] = useState({});
  const [filterClosedAuction, setFilterClosedAuction] = useState([]);
  const [filterUpcomingLiveAuction, setFilterUpcomingLiveAuction] = useState(
    []
  );
  const [disabled, setDisabled] = useState(false);
  const [dateValid, setDateValid] = useState(true);
  // #136: the Sell Ownership and Minimum Bid messages are shown from state, as the date's is. They
  // used to rely on the form's :invalid styling alone, which an empty field only reached when the
  // date was missing too, and a 0 never did - so Bid Sell silently did nothing.
  const [shareValid, setShareValid] = useState(true);
  const [bidValid, setBidValid] = useState(true);
  // #136 row 1208: the server's refusal, shown in the dialog. A team with a running listing is not
  // offered for sale, but a page opened before it was listed (another tab) still is, and the server
  // refuses that second listing ('This auction is already running.').
  const [sellError, setSellError] = useState("");
  const [dataListRecent, setDataListRecent] = useState([]);
  const [totalRows, setTotalRows] = useState(1);
  const [totalRowsWin, setTotalRowsWin] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const [currentPageSell, setCurrentPageSell] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  const [loading, setLoading] = useState(false);

  const [key, setKey] = useState(() => {
    return localStorage.getItem("activeTabSellAuction") || 'Live';
  });

  useEffect(() => {
    localStorage.setItem("activeTabSellAuction", key);
  }, [key]);

  const navigate = useNavigate();
  const initialRegForm = {
    startingBid: "",
    ownerShipSold: "",
    startDate: "",
  };
  const [regForm, setRegForm] = useState(initialRegForm);
  // A listing request in flight. The ref is the re-entry guard - a double click can reach
  // handleSell twice before the state change re-renders the disabled button.
  const [isSelling, setIsSelling] = useState(false);
  const isSellingRef = useRef(false);
  // #182/#191: what the open tab was last loaded with - search included - for the quiet reloads
  // (reconnect, tab shown again, a push). A reload function captured by the tab effect went stale
  // as soon as a search loaded something else.
  const lastQueryRef = useRef(null);
  const listSeqRef = useRef(0);
  const spinnerLoadsRef = useRef(0);
  const refetchTimerRef = useRef(null);
  const refetchDeadlineRef = useRef(0);
  const handleClose = () => {
    setShowView(false);
    setDateValid(true);
    setShareValid(true);
    setBidValid(true);
    setSellError("");
  };

  const handleShowView = (row) => {
    // The modal's inputs are fresh each time it opens, so the form behind them must be too -
    // otherwise the previous row's share, bid and date would be sent for this one.
    setRegForm(initialRegForm);
    setValidated(false);
    setDateValid(true);
    setShareValid(true);
    setBidValid(true);
    setSellError("");
    setShowView(true);

    setAuctionToSellData(row);
  };

  const handlebidIncrementToSell = async (e) => {
    e.preventDefault();
    setBidIncrementToSell(e.target.value);
  };

  const sidebarfun = () => {
    setData(!data);
  };
  const isUser = JSON.parse(localStorage.getItem("isUser"));
  const userId = isUser.userId;

  const handleSell = async (event) => {
    event?.preventDefault?.();

    // Every field is checked at once, so all of its messages show together and the dialog stays
    // open with what was typed.
    const { dateOk, shareOk, bidOk, startingBid } = checkSellForm(regForm);
    setDateValid(dateOk);
    setShareValid(shareOk);
    setBidValid(bidOk);
    if (!dateOk || !shareOk || !bidOk) {
      setValidated(true);
      return;
    }

    // const BidStatusAll = async () => {
    //     await GetWinnerAuction().then((res) => {
    //         const sortedData = res?.data?.data?.dataList.sort((a, b) => new Date(b.date) - new Date(a.date));
    //         sortedData.reverse();
    //         setBidStatusAuction([...sortedData]);
    //     });
    // }
    // BidStatusAll()

    if (isSellingRef.current) return;
    setSellError("");

    // Only the team, the price, the start and the share sold are read by the server: it takes
    // the seller and the holding from the signed-in player's own ownership row, not from
    // teamOwnerId / maxOwnerShip / bidAmount, which are still sent for the request model.
    const dataList = [
      {
        crudOperationId: true,
        id: 0,
        auctionId: auctionToSellData?.auctionId,
        teamId: auctionToSellData?.teamId,
        teamOwnerId: auctionToSellData?.teamOwnerId,
        bidAmount: auctionToSellData?.bidAmount,
        startingBid,
        bidIncrement: auctionToSellData?.bidIncrement,
        startDate: regForm?.startDate,
        maxOwnerShip: auctionToSellData?.maxOwnerShip,
        ownerShipSold: Number(regForm?.ownerShipSold),
      },
    ];

    isSellingRef.current = true;
    setIsSelling(true);
    try {
      const res = await SecondaryMarketBidSell(dataList);
      if (res?.data?.status == true) {
        setShowView(false);
        toast.success(res?.data?.message);
        setAuctionToSellData("");
        setStartingBidToSell("");
        setBidIncrementToSell("");
        // The listed share has left the holding for escrow - reload the Sell list so the row shows
        // what is listed and what is left, with Sell disabled while the listing runs (#137).
        getAdminData(
          {
            SearchTerm: searchTextLive ? searchTextLive : "",
            PageNumber: currentPageSell,
            PageSize: perPage,
            SortOrder: false,
          },
          { silent: true }
        );
      } else {
        // #9: RESALE_CLOSED is worded here, with the close in the player's timezone (the server's
        // text has UTC); CONTEST_STARTED (backend#214) and every other refusal show the server's text.
        // After either of the two the Sell list is reloaded, so the row's Sell turns off or the row goes.
        const errorCode = res?.data?.errorCode;
        const message = sellRefusalMessage(errorCode, auctionToSellData?.resaleClosesAt, readApiMessage(res));
        setSellError(message);
        toast.error(message);
        if (RESALE_OVER_CODES.includes(errorCode)) {
          getAdminData(
            {
              SearchTerm: searchTextLive ? searchTextLive : "",
              PageNumber: currentPageSell,
              PageSize: perPage,
              SortOrder: false,
            },
            { silent: true }
          );
        }
      }
    } finally {
      isSellingRef.current = false;
      setIsSelling(false);
    }
  };

  /**************/
  // useEffect(() => {

  //     const GetSecoderyAuction = async () => {
  //         await SecondryMarketSMgetAuctionById().then((response) => {

  //         })
  //     }
  //     GetSecoderyAuction();

  // }, [])

  /**************/

  // `silent` is for a background reload: no spinner over the tabs, and a reply with no list in
  // it leaves the table as it is.
  const getAdminData = async (data, { silent = false } = {}) => {
    lastQueryRef.current = { kind: "sell", query: data };
    if (!silent) setLoading(true);
    try {
      const response = await SecondaryMarketAuctionSell(data); // Call your API function
      if (!silent) setLoading(false);
      if (silent && !Array.isArray(response?.data?.data?.dataList)) return;
      if (response?.data) {
        setAuctionWinner(
          response?.data?.data?.dataList.filter(
            (event) => event.status === "Live"
          ) || []
        );
        // Set the item list

      //Pandey pagination in sell Auction
      setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  // useEffect(() => {
  //   const data = {
  //     PageNumber: currentPageSell,
  //     PageSize: perPage,
  //     SortOrder: false,
  //   };
  //   getAdminData(data); // Fetch data when currentPage changes
  // }, [currentPageSell]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      SearchTerm: searchTextLive ? searchTextLive : "",
      // SortColumn: searchTextLive  !== "" ? "" : "status",
      PageNumber: currentPageSell,
      PageSize: newPerPage,
      SortOrder: false,
    };
    getAdminData(data);

    setPerPage(newPerPage); // Update items per page
      currentPageSell(1)   // Reset to first page when items per page changes
    
  };

  const handlePerPageChange1 = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      SearchTerm: searchTextUpcomingLive ? `Closed,Archive, ${searchTextUpcomingLive}` : "Closed,Archive",
      SortColumn: searchTextUpcomingLive  !== "" ? "" : "status",
      PageNumber: currentPageClosed,
      PageSize: newPerPage,
      SortOrder: false,
    };
    BidStatusAll(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPageClosed(1); // Reset to first page when items per page changes
  };

  const handlePerPageChange2 = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      SearchTerm: searchTextUpcomingLive ? `Live,Upcoming,Paused, ${searchTextUpcomingLive}` : "Live,Upcoming,Paused",
      SortColumn: searchTextUpcomingLive  !== "" ? "" : "status",
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    BidStatusAll(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPageSell < Math.ceil(totalRows)) {
      setCurrentPageSell((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handleNextPage1 = () => {
    if (currentPage < Math.ceil(totalRowsWin)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handleNextPageClosed = () => {
    if (currentPageClosed < Math.ceil(totalRowsWin)) {
      setCurrentPageClosed((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPageSell > 1) {
      setCurrentPageSell((prevPage) => prevPage - 1); // Go to previous page
    }
  };
  const handlePreviousPage1 = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };
  const handlePreviousPageClosed = () => {
    if (currentPageClosed > 1) {
      setCurrentPageClosed((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const handelForm = (e) => {
    if (e.target.name === "ownerShipSold") setShareValid(true);
    if (e.target.name === "startingBid") setBidValid(true);
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value,
    });
  };

  const handelDate = (e) => {
    setDateValid(true);
    setRegForm({
      ...regForm,
      startDate: e,
    });
  };

  const btnplacebid = (item) => {
    // #191: without its clock fields - router state survives a reload, and SecodaryPlaceBid takes
    // its countdown from the server only.
    navigate(`/Player/SecodaryPlaceBid?auctionId`, { state: withoutClockFields(item) });
  };
  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }

  const column = [
    {
      name: "#",
      selector: (row, index) => index + 1,
    },
    {
      name: "Team Name",
      selector: (row) => row.teamName,
      sortable: true,
    },
    {
      name: "Auction Name",
      selector: (row) => row.auctionName,
      sortable: true,
    },

    {
      name: "Bid Amount",
      selector: (row) => row.bidAmount,
      sortable: true,
    },
    {
      // #137: the share of this team the player has not listed yet, and the share on listings that
      // have not settled. The row stays here while a listing runs, so the seller sees both.
      name: "Available Share",
      selector: (row) => row.availableShare,
      format: (row) => `${row.availableShare ?? 0}%`,
      sortable: true,
    },
    {
      name: "Listed Share",
      selector: (row) => row.listedShare,
      format: (row) => `${row.listedShare ?? 0}%`,
      sortable: true,
    },
    {
      name: "Bid Increment",
      selector: (row) => row.bidIncrement,
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => {
        // The server takes one listing of a team at a time - this player's or a co-owner's - and none
        // once resale has closed (#9). The reason is printed under the disabled button (#265): a
        // tooltip never shows on a touch screen. The tooltip stays on a wrapper because Bootstrap
        // turns off pointer events on a disabled button.
        const reason =
          row.canSell === false
            ? (row.resaleClosed && resaleClosedMessage(row.resaleClosesAt)) ||
              "A listing of this team is running. You can sell again once it closes."
            : undefined;
        return (
          <div className="py-2">
            <span title={reason}>
              <Button
                disabled={row.canSell === false}
                onClick={() => handleShowView(row)}
              >
                Sell
              </Button>
            </span>
            {reason && <small className="d-block text-muted mt-1">{reason}</small>}
          </div>
        );
      },
      wrap: true,
      minWidth: "220px",
    },
  ];

  // const handleSearchLive = (e) => {
  //   setSearchTextLive(e.target.value);
  // };

  const filteredDataAuctionWinner = searchTextLive
    ? auctionWinner.filter((item) => {
        return (
          item.status.toLowerCase() === "live" &&
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextLive.toLowerCase()) || item?.teamName
            ?.toLowerCase()
            .includes(searchTextLive.toLowerCase())
        );
      })
    : auctionWinner;

  // --- Live listings (#191) ----------------------------------------------------------------------
  // The server owns every status change - the page, ReceiveSMBidStatus and ReceiveCurrentSMBid - and
  // this list only merges what it says. It used to decide for itself: a one-second interval re-sorted
  // and rewrote every row, a countdown reaching 00:00 marked a listing Closed and reloaded the whole
  // window, an Upcoming one turned Live with a full BidTime on the device clock, and a Live row
  // missing from a push was taken for closed.

  // Asks for the listings tab again, quietly, with the query it was last loaded with.
  const refetchListings = () => {
    const last = lastQueryRef.current;
    if (last?.kind === "listings") BidStatusAll(last.query, { silent: true });
  };

  // A pending refetch is never brought forward - a push-triggered one waits for the status job on
  // purpose - as on the Auctions grid.
  const scheduleListingsRefetch = (delayMs) => {
    const deadline = Date.now() + delayMs;
    if (refetchTimerRef.current && refetchDeadlineRef.current >= deadline) return;

    clearTimeout(refetchTimerRef.current);
    refetchDeadlineRef.current = deadline;
    refetchTimerRef.current = setTimeout(() => {
      refetchTimerRef.current = null;
      refetchListings();
    }, delayMs);
  };

  useEffect(() => {
    const refetchTimer = refetchTimerRef;
    return () => clearTimeout(refetchTimer.current);
  }, []);

  // The Worker's push of every running listing, and of one it has just closed (kept in the push for
  // 20 s however it closed). Merged into the rows it names and nothing else: since #180 a push
  // carries only the listings this player may see, so a row missing from it says nothing.
  useHubEvent("ReceiveSMBidStatus", (data) => {
    if (!Array.isArray(data)) return;
    const receivedAt = Date.now();

    // Compared before the merge below changes the rows. A listing opening or closing moves the page
    // - the next listing, the totals - which the push does not carry, so it costs a quiet refetch.
    const livenessChanged = pageLivenessChanged(BidStatusAuction, data, listingKey);

    setBidStatusAuction((prev) => mergePushedRows(prev, data, SM_STATUS_FIELDS, listingKey));
    setClocks((prev) => syncTimerEnds(prev, data, receivedAt, { keyOf: listingKey }));

    if (livenessChanged) scheduleListingsRefetch(PUSH_REFETCH_DELAY_MS);
  });

  // Sent when someone bids. Only a live listing takes bids, and a bid restarts its clock.
  useHubEvent("ReceiveCurrentSMBid", (data) => {
    const live = Array.isArray(data) ? data.filter((item) => item?.status === "Live") : [];
    if (live.length === 0) return;
    const receivedAt = Date.now();

    setBidStatusAuction((prev) => mergePushedRows(prev, live, SM_CURRENT_BID_FIELDS, listingKey));
    setClocks((prev) => syncTimerEnds(prev, live, receivedAt, { keyOf: listingKey }));
  });

  // A listing was created. Its payload carries none of this player's flags nor the page it belongs
  // on, so instead of appending it to whatever page is showing, the page is asked for again.
  useHubEvent("GetRecentSMAuction", () => {
    scheduleListingsRefetch(QUICK_REFETCH_DELAY_MS);
  });

  // When the first Upcoming listing on the page is due to open, ask for the page again just after.
  // The next push says so within 7 s anyway; this only makes it prompt. The start is the server's
  // UTC moved by that row's own offset (device clock - server clock, as its page arrived), and each
  // start gets at most two asks, so a listing the server does not open is not asked about forever.
  const startOffsetsRef = useRef({});
  const startAttemptsRef = useRef({});
  const [startCheck, setStartCheck] = useState(0);
  useEffect(() => {
    if (key !== "Live") return undefined;

    const now = Date.now();
    let next = null;
    BidStatusAuction.forEach((row) => {
      const startUtc = parseServerUtc(row?.startDate);
      if (row?.status !== "Upcoming" || !Number.isFinite(startUtc)) return;

      const startKey = `${listingKey(row)}@${startUtc}`;
      const attempts = startAttemptsRef.current[startKey] ?? 0;
      if (attempts >= START_REFETCH_ATTEMPTS) return;

      const startsAt = startUtc + (startOffsetsRef.current[listingKey(row)] ?? 0);
      const fireAt = startsAt + START_REFETCH_DELAY_MS + attempts * START_RETRY_MS;
      if (!next || fireAt < next.fireAt) next = { startKey, startsAt, fireAt };
    });
    if (!next) return undefined;

    const { startKey, startsAt, fireAt } = next;
    const timeoutId =
      startsAt - now > START_LOOKAHEAD_MS
        ? // Too far off for a timer of its own: look again once it is close.
          setTimeout(
            () => setStartCheck((n) => n + 1),
            Math.min(startsAt - START_LOOKAHEAD_MS - now, MAX_TIMEOUT_MS)
          )
        : setTimeout(() => {
            startAttemptsRef.current[startKey] = (startAttemptsRef.current[startKey] ?? 0) + 1;
            refetchListings();
            // Arms the retry even if the reply changes nothing.
            setStartCheck((n) => n + 1);
          }, Math.max(0, fireAt - now));

    return () => clearTimeout(timeoutId);
    // refetchListings only reads refs and calls setters; it is not a reason to re-arm the timer.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [BidStatusAuction, key, startCheck]);

  const columns = [
    {
      name: "Team Name",
      selector: (row) => row.teamName,
      sortable: true,
    },
    {
      name: "Auction Name",
      selector: (row) => row.auctionName,
      sortable: true,
    },
    {
      name: "Contest Name",
      selector: (row) => row.tournamentName,
      sortable: true,
    },
    {
      name: "Sport Name",
      selector: (row) => row.sportName,
      sortable: true,
    },

    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
      width: "200px",
    },

    {
      name: "Bid Time Limit",
      selector: (row) => row.bidTime,
      format: (row) => bidTimeLabel(row.bidTime),
      sortable: true,
    },

    {
      name: "Starting Bid",
      selector: (row) => row.startingBid,
      sortable: true,
    },
    {
      name: "Bid Increment",
      selector: (row) => row.bidIncrement,
      sortable: true,
    },
    {
      name: "Share",
      selector: (row) => (row.ownerShipShare ? `${row.ownerShipShare}%` : "-"),
      sortable: true,
    },
    {
      name: "Highest Bidder",
      selector: (row) => row.bidPlacedByName || "-",
      sortable: true,
    },

    {
      name: "Bid Status",
      selector: (row) =>
        // #191: the server's clock - a Live listing counts down to its endsAtUtc, a Paused one
        // shows the time it was frozen at. Neither ever changes the row's status.
        row.status === "Upcoming" ? (
          <>
            <span style={{ color: "#f9c114" }}>Upcoming</span>
          </>
        ) : row.status === "Live" ? (
          <>
            <span style={{ color: "#043bc7" }}>
              Live <LotCountdown endsAt={clocks[listingKey(row)]?.endsAt} />
            </span>
          </>
        ) : row.status === "Closed" ? (
          <>
            <span style={{ color: "red" }}>Closed</span>
          </>
        ) : row.status === "Paused" ? (
          <>
            <span style={{ color: "red" }}>
              {/* FE-14 QA: the status only, no frozen time - as on the Auction page. */}
              Paused
            </span>
          </>
        ) : row.status === "Archive" ? (
          <>
            <span style={{ color: "red" }}>Closed</span>
          </>
        ) : (
          <>
            <span style={{ color: "green" }}>Play</span>
          </>
        ),
    },
    {
      name: "Created By",
      selector: (row) => row.createdByName,
      sortable: true,
    },
    {
      // #304: pinned to the right edge on the Live and Upcoming tab (.sticky-action-table).
      name: "Action",
      selector: (row) => (
        <>
          {row.status === "Live" ? (
            <div className="sticky-tab">
              <button
                // className="tablebtn placebid disable"
                className={
                  row.createdById === userId
                    ? "tablebtn placebid disable"
                    : "tablebtn placebid"
                }
                disabled={row.createdById === userId}
                onClick={() => btnplacebid(row)}
              >
                Place Bid
              </button>{" "}
            </div>
          ) : (
            <div className="sticky-tab">
              <button
                className="tablebtn placebid disable"
                disabled
                onClick={() => btnplacebid(row)}
              >
                Place Bid
              </button>
            </div>
          )}
        </>
      ),
    },
  ];

  const Columns_SM_Winners = [
    {
      name: "Team Name",
      selector: (row) => row.teamName,
      sortable: true,
    },
    {
      name: "Auction Name",
      selector: (row) => row.auctionName,
      sortable: true,
    },

    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        const localTime = convertUTCToLocalTime(row?.startDate + "Z");
        const dayjsDate = dayjs(localTime);
        if (!dayjsDate.isValid()) {
          return <p>Invalid date</p>;
        }
        const formattedDate = dayjsDate.format("MM/DD/YYYY");
        const timePart = dayjsDate.format("hh:mm:ss A");
        return (
          <p>
            {formattedDate}, {timePart}
          </p>
        );
      },
    },

    {
      name: <strong>End Date & Time</strong>,
      selector: (row) => {
        if (!row?.endDate) return <p>Invalid date</p>;
        const localTime = convertUTCToLocalTime(row?.endDate + "Z");
        const dayjsDate = dayjs(localTime);
        if (!dayjsDate.isValid()) {
          return <p>Invalid date</p>;
        }
        const formattedDate = dayjsDate.format("MM/DD/YYYY");
        const timePart = dayjsDate.format("hh:mm:ss A");
        return (
          <p>
            {formattedDate}, {timePart}
          </p>
        );
      },
    },

    {
      name: "Bid Amount",
      selector: (row) => row.bidTime,
      sortable: true,
    },

    {
      name: "Bid Status",
      selector: (row) =>
        row.status === "Upcoming" ? (
          <>
            <span style={{ color: "#f9c114" }}>Upcoming</span>
          </>
        ) : row.status === "Live" ? (
          <>
            <span style={{ color: "#043bc7" }}>Live</span>
          </>
        ) : row.status === "Closed" ? (
          <>
            <span style={{ color: "red" }}>Closed</span>
          </>
        ) : row.status === "Paused" ? (
          <>
            <span style={{ color: "red" }}>Paused</span>
          </>
        ) : (
          <>
            <span style={{ color: "green" }}>Play</span>
          </>
        ),
    },
  ];

  const handleSearchClose = (e) => {
    setSearchTextClose(e.target.value);
  };
  // const handleSearchUpcomingLive = (e) => {
  //   setSearchTextUpcomingLive(e.target.value);
  // };

  const filteredDataUpcomingLiveAuction = searchTextUpcomingLive
    ? filterUpcomingLiveAuction.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.teamName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.sportsName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.createdByName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.status
            .toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase())
        );
      })
    : filterUpcomingLiveAuction;

  const filteredDataCloseAuction = searchTextClose
    ? filterClosedAuction.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextClose?.toLowerCase()) ||
          item?.teamName
            ?.toLowerCase()
            .includes(searchTextClose?.toLowerCase()) ||
          item.sportsName
            ?.toLowerCase()
            .includes(searchTextClose?.toLowerCase()) ||
          item?.createdByName
            ?.toLowerCase()
            .includes(searchTextClose.toLowerCase()) ||
          item?.status?.toLowerCase().includes(searchTextClose?.toLowerCase())
        );
      })
    : filterClosedAuction;

  // The order the listings have always been shown in - by start, then team - now sorted once per
  // change instead of by a one-second interval (#191). Stable: the level breaks a tie between a
  // team's two listings.
  const sortedListings = useMemo(
    () =>
      [...BidStatusAuction].sort(
        (a, b) =>
          parseServerUtc(a?.startDate) - parseServerUtc(b?.startDate) ||
          a?.teamId - b?.teamId ||
          (a?.auctionLevel ?? 0) - (b?.auctionLevel ?? 0)
      ),
    [BidStatusAuction]
  );

  const filterListData = useMemo(() => {
    let allList = sortedListings.filter((item) => {
      return searchTextUpcomingLive?.length > 0
        ? item?.auctionName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
            item?.teamName
              ?.toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) ||
            item?.sportsName
              ?.toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) ||
            item?.createdByName
              ?.toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) ||
            item?.status
              .toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) || 
             item?.tournamentName
              .toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) ||
              item?.sportName
              .toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase())
        : item;
    });

    let liveOnTop = allList.filter((event) => event.status === "Live");
    let otherLeft = allList.filter((event) => event.status !== "Live");

    return [...liveOnTop, ...otherLeft];
  }, [sortedListings, searchTextUpcomingLive]);

  // const filteredDataSMWinners = searchTextClose ? filterClosedAuction.filter((item) => {
  //     return item?.auctionName?.toLowerCase().includes(searchTextClose?.toLowerCase()) || item?.teamName?.toLowerCase().includes(searchTextClose?.toLowerCase()) || item.sportsName?.toLowerCase().includes(searchTextClose?.toLowerCase()) || item?.createdByName?.toLowerCase().includes(searchTextClose.toLowerCase()) || item?.status?.toLowerCase().includes(searchTextClose?.toLowerCase())
  // }) : filterClosedAuction;

  useEffect(() => {
    const filterUpcomingsLivesAuction = (eventArray) => {
      return eventArray?.filter(
        (event) => event.status === "Upcoming" || event.status === "Live"
      );
    };

    setFilterUpcomingLiveAuction(filterUpcomingsLivesAuction(BidStatusAuction));

    const filterClosesAuction = (eventArray) => {
      return eventArray?.filter(
        (event) => event.status === "Closed" || event.status === "Archive"
      );
    };
    setFilterClosedAuction(filterClosesAuction(BidStatusAuction));
  }, [signalRData, BidStatusAuction]);

  // Loads the Live and Upcoming, or the Closed, tab. `silent` is for a background reload: no
  // spinner over the tabs, and a reply with no list in it leaves the table as it is (it used to throw
  // on .sort). Only the latest request may touch the rows; an older reply arriving late is dropped.
  const BidStatusAll = async (data, { silent = false } = {}) => {
    const seq = ++listSeqRef.current;
    lastQueryRef.current = { kind: "listings", query: data };
    if (!silent) {
      spinnerLoadsRef.current += 1;
      setLoading(true);
    }

    try {
      const response = await GetWinnerAuctionData(data); // Call your API function
      const receivedAt = Date.now();
      //   if (response?.data) {
      //    setAuctionWinner(response?.data?.data?.dataList.filter((event) => event.status === "Live") || [])
      //     // Set the item list
      //     setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      //   }
      const dataList = response?.data?.data?.dataList;
      if (seq !== listSeqRef.current || !Array.isArray(dataList)) return;

      // A Live listing with no time left is shown Closed, as before. #191: the clocks come from the
      // server's instants (syncTimerEnds), and a push received while this page was on its way is
      // newer than the page.
      const rows = normalizeGridRows(dataList);
      const offsets = {};
      rows.forEach((row) => {
        const serverNow = parseServerUtc(row?.serverNowUtc);
        if (Number.isFinite(serverNow)) offsets[listingKey(row)] = receivedAt - serverNow;
      });
      startOffsetsRef.current = offsets;
      setBidStatusAuction((prev) => preferNewerRows(rows, prev, SM_STATUS_FIELDS, listingKey));
      setClocks((prev) => syncTimerEnds(prev, rows, receivedAt, { prune: true, keyOf: listingKey }));

      setTotalRowsWin(response.data.data.totalPageSize || 0);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      if (!silent) {
        spinnerLoadsRef.current -= 1;
        if (spinnerLoadsRef.current === 0) setLoading(false);
      }
    }
  };

  // Reloads the open tab quietly, with what it was last loaded with.
  const reloadOpenTab = () => {
    const last = lastQueryRef.current;
    if (last?.kind === "sell") getAdminData(last.query, { silent: true });
    else if (last?.kind === "listings") BidStatusAll(last.query, { silent: true });
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    if(key === "Live"){
      const data = {
      SearchTerm: searchTextUpcomingLive ? `Live,Upcoming,Paused, ${searchTextUpcomingLive}` : "Live,Upcoming,Paused",
      SortColumn: searchTextUpcomingLive  !== "" ? "" : "status",
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
      BidStatusAll(data); // Fetch data when currentPage changes
    }else if(key === 'Closed'){
       const data1 =  {
      SearchTerm: searchTextUpcomingLive ? `Closed,Archive, ${searchTextUpcomingLive}` : "Closed,Archive",
      SortColumn: searchTextUpcomingLive  !== "" ? "" : "status",
      PageNumber: currentPageClosed,
      PageSize: perPage,
      SortOrder: false,
    };
      BidStatusAll(data1);
    }else if(key === 'Sell Auctions'){
      const data = {
      SearchTerm: searchTextLive ? searchTextLive : "",
      // SortColumn: searchTextLive  !== "" ? "" : "status",
      PageNumber: currentPageSell,
      PageSize: perPage,
      SortOrder: false,
    };
    getAdminData(data);
    }else{
      return undefined;
    }

    // A hidden tab may have missed pushes: reload what is showing when it shows again - quietly,
    // and with the query it was last loaded with (a search included).
    const handleVisibilityChange = () => {
      if (document.visibilityState !== "visible") return;
      const last = lastQueryRef.current;
      if (last?.kind === "sell") getAdminData(last.query, { silent: true });
      else if (last?.kind === "listings") BidStatusAll(last.query, { silent: true });
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [currentPage, currentPageClosed, perPage, key, currentPageClosed, currentPageSell]); // Dependency on currentPage

  // #182: what was pushed while the live connection was down is lost; reload the open tab.
  useHubResync(() => reloadOpenTab());

  // useEffect(() => {
  //   const data = {
  //     PageNumber: currentPageSell,
  //     PageSize: perPage,
  //     SortOrder: false,
  //   };
  //   getAdminData(data); // Fetch data when currentPage changes
  // }, [currentPageSell]);

  // const handleSelect = (k) => {
    // setKey(k);
    // if (k === 'profile') {
    //     const BidStatusAll = async () => {
    //         await GetWinnerAuction().then((res) => {
    //             const sortedData = res?.data?.data?.dataList.sort((a, b) => new Date(b.date) - new Date(a.date));
    //             sortedData.reverse();
    //             setBidStatusAuction([...sortedData]);
    //         });
    //     }
    //     BidStatusAll()
    // }
  // };
  // const clearSearch = () => {
  //   setSearchTextLive("");
  //   setSearchTextClose("");
  //   setSearchTextUpcomingLive("");
  // };

// implement searching functionlity from debounce

const timeoutRef = useRef(null);

  const executeSearch = useCallback((query) => {
    // Replace this console log with your actual data fetching logic (e.g., Axios call, Redux action)
    const data = {
      SearchTerm: query ? `Live,Upcoming,Paused, ${query}` : "Live,Upcoming,Paused",
      SortColumn: query !== "" ? "" : "status",
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };

    const data1 =  {
      SearchTerm: query ? `Closed,Archive, ${query}` : "Closed,Archive",
      SortColumn: query !== "" ? "" : "status",
      PageNumber: currentPageClosed,
      PageSize: perPage,
      SortOrder: false,
    }

     const data3 = {
       SearchTerm: query ? query : "",
      // SortColumn: query  !== "" ? "" : "status",
      PageNumber: currentPageSell,
      PageSize: perPage,
      SortOrder: false,
    };


    if(key === "Live"){
      BidStatusAll(data); // Fetch data when currentPage changes
    }else if(key === 'Closed'){
      BidStatusAll(data1);
    }else if(key === "Sell Auctions"){
      getAdminData(data3);
    }
    console.log("Searching data for:", query);
    // Example: fetchData(query);
  }, [key, currentPage, currentPageClosed, currentPageSell, perPage]); // Include dependencies to ensure latest values

  // The debounced change handler for the input field
  const handleSearchUpcomingLive = (e) => {
    const value = e.target.value;
    if(key  ===  'Sell Auctions'){
      setSearchTextLive(value);
    }else{
    setSearchTextUpcomingLive(value);
    }

    // 1. Clear any previous pending timeouts
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // 2. Set a new timeout
    timeoutRef.current = setTimeout(() => {
      // 3. Call the actual search function after 2000ms (2 seconds)
      executeSearch(value);
    }, 2000);
  };

  // Function to clear the search input immediately
  const clearSearch = () => {
    // Clear any pending timeouts when the input is cleared manually
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setSearchTextLive("");
    setSearchTextClose("");
    setSearchTextUpcomingLive("");
    // Trigger an immediate clear search (or re-fetch all data)
    executeSearch('');
  };


  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <Modal size="lg" show={showView} onHide={handleClose}>
        <Form noValidate validated={validated}>
          <Modal.Header>
            <Modal.Title>Resale Bid</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Form.Group as={Col} md="6 mt-3" controlId="validationCustom02">
                <Form.Label>Auction Name</Form.Label>
                <Form.Control
                  name="firstName"
                  disabled
                  value={auctionToSellData?.auctionName}
                  required
                  type="text"
                  placeholder="Enter your first name"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter First Name.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Team Name</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    name="teamName"
                    disabled
                    placeholder=" Enter your last name"
                    value={auctionToSellData?.teamName}
                    aria-describedby="inputGroupPrepend"
                    readOnly
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Last Winning Amount</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    disabled
                    name="bidAmount"
                    placeholder=" Enter your last name"
                    value={auctionToSellData?.bidAmount}
                    aria-describedby="inputGroupPrepend"
                    readOnly
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Current Share</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    disabled
                    name="lastName"
                    placeholder=" Enter your last name"
                    value={
                      auctionToSellData?.maxOwnerShip != null
                        ? `${auctionToSellData.maxOwnerShip}%`
                        : ""
                    }
                    aria-describedby="inputGroupPrepend"
                    readOnly
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Bid Increment </Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    name="lastName"
                    disabled
                    placeholder=" Enter Bid Increment for Sell"
                    value={auctionToSellData?.bidIncrement}
                    aria-describedby="inputGroupPrepend"
                    onChange={(e) => handlebidIncrementToSell(e)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please select a bid increment.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Sell Ownership</Form.Label>
                <InputGroup hasValidation>
                  <Form.Select
                    onChange={handelForm}
                    name="ownerShipSold"
                    className="select-option"
                    required
                    as="select"
                    value={regForm.ownerShipSold}
                    isInvalid={!shareValid}
                  >
                    <option value={""}>Select Ownership</option>
                    {/* Only what the player still holds - the server refuses more. */}
                    {SELL_SHARE_OPTIONS.filter(
                      (share) =>
                        share <= Number(auctionToSellData?.maxOwnerShip)
                    ).map((share) => (
                      <option key={share} value={String(share)}>
                        {share}%
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback
                    type="invalid"
                    style={{ display: shareValid ? "none" : "block" }}
                  >
                    {SELL_SHARE_REQUIRED}
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Minimum Bid</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    name="startingBid"
                    placeholder=" Enter minimum bid to sell"
                    required
                    aria-describedby="inputGroupPrepend"
                    onChange={handelForm}
                    isInvalid={!bidValid}
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    style={{ display: bidValid ? "none" : "block" }}
                  >
                    Enter a minimum bid greater than 0.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group as={Col} md={6} className="mt-3">
                <Form.Label>Start Bid Date and Time</Form.Label>
                <DatePicker
                  format="MM/dd/yyyy hh:mm:ss aa"
                  showMeridian
                  placeholder="Select start date and time"
                  disabledDate={(date) =>
                    date < new Date().setHours(0, 0, 0, 0)
                  }
                  name="startDate"
                  className={
                    dateValid
                      ? "Auction-Date resale-date"
                      : "Auction-Date resale-date is-invalid"
                  }
                  onChange={handelDate}
                  required
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={{ display: dateValid ? "none" : "block" }}
                >
                  {DATE_TIME_REQUIRED}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            {sellError && (
              <p className="err-message mt-3 mb-0" role="alert">
                {sellError}
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={isSelling}
            >
              Close
            </Button>
            <Button variant="primary" onClick={handleSell} disabled={isSelling}>
              {isSelling ? "Listing..." : "Bid Sell"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Secondary Market</h1>
          <div className="group_data_table">
            <div className="group_data_table tabs-auction">
              <div className="tabs-box">
                {loading ? (
                  <Loader />
                ) : (
                  <Tabs
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    defaultActiveKey="Sell Auctions"
                    id="auctiontabs"
                    className="mb-0 tab-list-item"
                    justify
                  // onSelect={handleSelect}
                  >
                    <Tab eventKey="Sell Auctions" title="Sell Auctions">
                      <div className="search-input filter auction-filter">
                        <input
                          type="text"
                          className="form-control mb-3 mt-3"
                          placeholder="Search..."
                          value={searchTextLive}
                          onChange={handleSearchUpcomingLive}
                        />
                        {searchTextLive && (
                          <button className="btn btn-clear" onClick={clearSearch}>
                            <span>&times;</span>{" "}
                            {/* This represents the close icon */}
                          </button>
                        )}
                      </div>

                      {/* <DataTable
                                            title="dfsfd"
                                            columns={column}
                                            data={filteredDataAuctionWinner}
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                            paginationTotalRows={filteredDataAuctionWinner?.length}
                                        /> */}

                      <div>
                        <DataTable
                          columns={column}
                          data={filteredDataAuctionWinner}
                          paginationPerPage={perPage}
                          paginationTotalRows={totalRows * 10}
                          paginationDefaultPage={currentPageSell}
                          onChangePage={setCurrentPageSell}
                        />
                        {totalRows >= 1 && (
                          <Row>
                            <Col md={12} className="text-right">
                              <div className="pagination-controls">
                                <label>Rows per page: </label>
                                <select
                                  id="itemsPerPage"
                                  value={perPage}
                                  onChange={handlePerPageChange}
                                >
                                  {pageOptions.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <Button
                                  onClick={handlePreviousPage}
                                  disabled={currentPageSell === 1}
                                >
                                  <icons.ArrowLeft></icons.ArrowLeft>
                                </Button>
                                <span>
                                  {currentPageSell} of {totalRows}{" "}
                                </span>
                                <Button
                                  onClick={handleNextPage}
                                  disabled={currentPageSell >= Math.ceil(totalRows)}
                                >
                                  <icons.ArrowRight></icons.ArrowRight>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </Tab>

                    <Tab eventKey="Live" title="Live and Upcoming">
                      <div className="auctiontabs sticky-action-table">
                        <div className="search-input filter auction-filter">
                          <input
                            type="text"
                            className="form-control mb-3 mt-3"
                            placeholder="Search..."
                            value={searchTextUpcomingLive}
                            onChange={handleSearchUpcomingLive}
                          />
                          {searchTextUpcomingLive && (
                            <button
                              className="btn btn-clear"
                              onClick={clearSearch}
                            >
                              <span>&times;</span>{" "}
                              {/* This represents the close icon */}
                            </button>
                          )}
                        </div>

                        {/* <DataTable
                                                columns={columns}
                                                data={filterListData?.filter((event) => event.status === "Upcoming" || event.status === "Live")}
                                                pagination
                                                paginationPerPage={10}
                                                defaultSortFieldId={1}
                                                paginationRowsPerPageOptions={[10, 20, 30]}
                                            /> */}

                        <div>
                          <DataTable
                            columns={columns}
                            data={sortedListings.filter(
                              (event) =>
                                event.status === "Upcoming" ||
                                event.status === "Live" ||
                                event.status === "Paused"
                            )}
                            paginationPerPage={perPage}
                            paginationTotalRows={totalRowsWin * 10}
                            paginationDefaultPage={currentPage}
                            onChangePage={setCurrentPage}
                          />
                          {totalRowsWin >= 1 && (
                            <Row>
                              <Col md={12} className="text-right">
                                <div className="pagination-controls">
                                  <label>Rows page: </label>
                                  <select
                                    id="itemsPerPage"
                                    value={perPage}
                                    onChange={handlePerPageChange2}
                                  >
                                    {pageOptions.map((option) => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>

                                  <Button
                                    onClick={handlePreviousPage1}
                                    disabled={currentPage === 1}
                                  >
                                    <icons.ArrowLeft></icons.ArrowLeft>
                                  </Button>
                                  <span>
                                    {" "}
                                    Page {currentPage} of {totalRowsWin}{" "}
                                  </span>
                                  <Button
                                    onClick={handleNextPage1}
                                    disabled={
                                      currentPage >= Math.ceil(totalRowsWin)
                                    }
                                  >
                                    <icons.ArrowRight></icons.ArrowRight>
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </div>
                      </div>
                    </Tab>

                    <Tab eventKey="Closed" title="Closed">
                      <div>
                        <div className="auctiontabs">
                          <div className="search-input filter auction-filter">
                            <input
                              type="text"
                              className="form-control mb-3 mt-3"
                              placeholder="Search..."
                              value={searchTextUpcomingLive}
                              onChange={handleSearchUpcomingLive}
                            />
                            {searchTextUpcomingLive && (
                              <button
                                className="btn btn-clear"
                                onClick={clearSearch}
                              >
                                <span>&times;</span>{" "}
                                {/* This represents the close icon */}
                              </button>
                            )}
                          </div>
                          <div>
                            <DataTable
                              columns={columns}
                              data={sortedListings.filter(
                                (event) =>
                                  event.status === "Closed" ||
                                  event.status === "Archive"
                              )}
                              paginationPerPage={perPage}
                              paginationTotalRows={totalRowsWin * 10}
                              paginationDefaultPage={currentPageClosed}
                              onChangePage={setCurrentPageClosed}
                            />
                            {totalRowsWin >= 1 && (
                              <Row>
                                <Col md={12} className="text-right">
                                  <div className="pagination-controls">
                                    <label>Rows page: </label>
                                    <select
                                      id="itemsPerPage"
                                      value={perPage}
                                      onChange={handlePerPageChange1}
                                    >
                                      {pageOptions.map((option) => (
                                        <option key={option} value={option}>
                                          {option}
                                        </option>
                                      ))}
                                    </select>

                                    <Button
                                      onClick={handlePreviousPageClosed}
                                      disabled={currentPageClosed === 1}
                                    >
                                      <icons.ArrowLeft></icons.ArrowLeft>
                                    </Button>
                                    <span>
                                      {" "}
                                      Page {currentPageClosed} of {totalRowsWin}{" "}
                                    </span>
                                    <Button
                                      onClick={handleNextPageClosed}
                                      disabled={
                                        currentPageClosed >= Math.ceil(totalRowsWin)
                                      }
                                    >
                                      <icons.ArrowRight></icons.ArrowRight>
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </div>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={data ? "Footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
